const {
  SHOW_NOTIFICATION_DIALOG,
  HIDE_NOTIFICATION_DIALOG,
} = require("./action-type");

export const showNotificationDialog = (title, content,button) => {
  return {
    type: SHOW_NOTIFICATION_DIALOG,
    payload: { title, content,button },
  };
};

export const hideNotificationDialog = () => {
  return {
    type: HIDE_NOTIFICATION_DIALOG,
  };
};
